import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";

// Redux-Functions
import { selectToken } from "../redux/userSlice";

// handle the private routes
const PrivateRoute = (props) => {
    const token = useSelector(selectToken);

    if (token) {
        return <Outlet>
            {props?.children}
        </Outlet>;
    } else {
        return <Navigate to="/expired" replace />;
    }
}

export default PrivateRoute;

PrivateRoute.prototypes = {
    children: PropTypes.node.isRequired
}